import { q } from "../helper/q"
import "vanilla-autofill-event"

export const floatInputInit = () => {
  const inputs = Array.from(document.querySelectorAll(".floatInput"))
  const orderContainer = q(".orderContainer")
  if (orderContainer) {
    console.log("no init float input")
    return null
  }
  inputs.map(input => {
    if (!input.dataset.floating) {
      input.dataset.floating = true
      const wrapper = wrapInput(input)
      const placeholder = input.placeholder

      addLabel(wrapper, input)
      if (input.value) wrapper.classList.add("floatInputFocus")

      input.addEventListener("focus", () => {
        wrapper.classList.add("floatInputFocus")
      })

      input.addEventListener("change", () => {
        wrapper.classList.add("floatInputFocus")
      })

      input.addEventListener("blur", () => {
        if (!input.value) {
          wrapper.classList.remove("floatInputFocus")
          wrapper.classList.remove("floatInputError")
          wrapper.querySelector(".floatInputLabel").innerHTML = placeholder
        }

        if (input.dataset.required) {
          if (input.value === "") {
            wrapper.classList.add("floatInputError")
            if (input.dataset.error !== "") {
              if (window.matchMedia("(min-width: 768px)").matches) {
                wrapper.querySelector(".floatInputLabel").innerHTML = input.dataset.error
              }
            }
          }
        }
      })
      input.addEventListener("valid", () => {
        input.parentNode.classList.remove("floatInputError")
        input.parentNode.querySelector(".floatInputLabel").innerHTML = input.dataset.placeholder
      })

      input.addEventListener("input", e => {
        if (input.dataset.required) {
          input.value = e.target.value
          if (input.value === "") {
            if (input.dataset.error !== "") {
              if (window.matchMedia("(min-width: 768px)").matches) {
                wrapper.querySelector(".floatInputLabel").innerHTML = input.dataset.error
              }
            }
          } else {
            wrapper.querySelector(".floatInputLabel").innerHTML = placeholder
            wrapper.classList.remove("floatInputError")
          }
        }
      })
    }
  })
}

const wrapInput = input => {
  const wrapper = document.createElement("div")
  wrapper.classList.add("floatInputWrapper")
  if (input.required) wrapper.classList.add("floatInputRequired")
  if (input.hidden) wrapper.classList.add("floatInputWrapperHidden")
  input.parentNode.insertBefore(wrapper, input)
  wrapper.appendChild(input)
  return wrapper
}

const addLabel = (wrapper, input) => {
  const label = document.createElement("div")
  label.classList.add("floatInputLabel")
  label.innerHTML = input.placeholder
  input.placeholder = ""
  wrapper.appendChild(label)
}
